import Reason from '@/generated/classes/Reason';
import { ReasonSelect as ReasonSelectBase } from '@/generated/classes/Reason';
import { ReasonChoix as ReasonChoixBase } from '@/generated/classes/Reason';
export default class ReasonExtend extends Reason {
  constructor() {
    super();
  }
}
export class ReasonSelect extends ReasonSelectBase {
  constructor() {
    super();
  }
}
export class ReasonChoix extends ReasonChoixBase {
  constructor() {
    super();
  }
}
